@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.overlay {
  background-color: rgba(0, 0, 0, 0.2);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 52;
}

.popup {
  animation-duration: 0.5s;
  animation-name: slidein;
  background-color: map.get(core.$colors, simpleWhite);
  border-radius: 2px;
  box-sizing: content-box;
  left: 50%;
  padding: 28px;
  position: absolute;
  top: 182px;
  transform: translate(-50%, 0%);
  width: 550px;

  @keyframes slidein {
    from {
      top: 0;
    }

    to {
      top: 182px;
    }
  }

  &Close {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 4px;
  }

  &Container {
    align-items: center;
    display: flex;
    flex-direction: column;

    &Body {
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    &Title {
      padding-bottom: 34px;
      text-align: center;
    }
  }
}
